export const STATUS_GARDEN_CREATED = Symbol('STAUTS_GARDEN_CREATED')
export const STATUS_GARDEN_DEPLOYMENT = Symbol('STATUS_GARDEN_DEPLOYMENT')
export const STATUS_GARDEN_SETUP = Symbol('STATUS_GARDEN_SETUP')
